import styled, { css } from 'styled-components';
import { ButtonContainer } from '../../button';
import { pxToRem } from '../../../design-tokens/style-utilities';
export const formFooterContainerStyles = ({ theme }) => css `
	&& {
		display: flex;
		justify-content: space-between;
		flex-flow: column-reverse wrap;
		margin: 0;
		width: auto;
		max-width: none;

		& > * {
			flex: 1 1 auto;
			margin-right: ${pxToRem(theme.spacing['100'])};
			margin-bottom: ${pxToRem(theme.spacing['100'])};
		}

		& > *:last-child {
			margin-right: 0;
		}

		${ButtonContainer} {
			max-width: 100%;
			margin: 0;

			/* NOTE: Using margin-top instead of gap as safari doesn't work well with gap and column-reverse */
			:not(:last-of-type) {
				margin-top: ${pxToRem(Number(theme.spacing[200]))};
			}
		}

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
			gap: ${pxToRem(Number(theme.spacing[200]))};
			flex-direction: row;

			& > * {
				flex: none;
			}

			& > *:last-child {
				margin-left: auto;
			}

			${ButtonContainer}:not(:last-of-type) {
				margin-top: 0;
			}
		}
	}
`;
export const FormFooterContainer = styled.footer `
	${formFooterContainerStyles}
`;
